module.exports = __webpack_public_path__ + "static/media/AppStore-button.08503f35.png";